export class TAModel {
  emailId: string;
  alternateEmailId: string;
  mobileNumber: string;
  name: string;
  department: string;
  id: number;
  image?: string
}
